<template>
	<div class="tab-container" v-if="tabList?.length > 0">
		<vue-horizontal class="scroller" :button="false">
			<div v-for="(tab, index) in tabList" :key="tab.id">
				<div
					class="tab"
					:class="{ selected: this.selectedTabIndex == index }"
					@click="updateSelectedTabIndex(index)"
				>
					{{ tab.name }}
				</div>
			</div>
		</vue-horizontal>
	</div>
	<div class="subtab-container" v-if="currentSubTabList?.length > 0">
		<vue-horizontal class="scroller" :button="false">
			<div v-for="(tab, index) in currentSubTabList" :key="tab.id">
				<div
					class="tab"
					:class="{ selected: this.selectedSubTabIndex == index }"
					@click="updateSelectedSubTabIndex(index)"
				>
					{{ tab.name }}
				</div>
			</div>
		</vue-horizontal>
	</div>
</template>

<script>
import VueHorizontal from "vue-horizontal";

export default {
	emits: ["changeSelectedTabID"],
	props: {
		tabList: {
			type: Array,
			default: () => [],
		},
		// initial selected
		tabID: {
			type: String,
			default: "",
		},
	},
	mounted: function() {
		this.selectedTabID = this.tabID ? this.tabID : "";
		this.didUpdateTabList();
	},
	data() {
		return {
			// load from props
			selectedTabID: this.tabID,
			selectedTabIndex: 0,// this.tabList[0].id,
			selectedSubTabIndex: 0,//"",
		};
	},
	computed: {
		currentSubTabList() {
			// console.log("currentSubTabList: " + this.selectedTabIndex);
			let selectedTab = this.tabList[this.selectedTabIndex];
			return selectedTab?.subList ? selectedTab.subList : [];
		},
	},
	watch: {
		// update
		tabList(newVal, oldVal) {
			if (newVal != oldVal) {
				// update selection
				this.didUpdateTabList();
			}
		},
		tabID(newVal, oldVal) {
			if (newVal != oldVal) {
				
				// 更新selected tab id
				this.selectedTabID = this.tabID;

				// 更新数据
				this.didUpdateTabList();
			}
		},
		selectedTabID(newVal, oldVal) {
			if (newVal != oldVal) {
				// update selection
				// console.log("Did Change Selected Tab ID: " + newVal);
				this.$emit("changeSelectedTabID", newVal);
			}
		},
	},
	methods: {
		// 使用传入的数据重新构建tab
		// 1. 重新创建tablist
		// 2. 根据当前的selectedTabID重新设置一级和二级的选中index
		// 3. 如果selectedTabID不再于tablList中，则清空并选择第一个数据。如果发生变动，这里自动触发callback
		didUpdateTabList() {
			// console.log("didUpdateTabList; tab id: " + this.selectedTabID);

			// todo,这里实现感觉有点粗糙

			// 使用selectedTabID更新index
			var tempIndex = -1;
			var subParentIndex = -1;
			var tempSubIndex = 0;
			var selectedTabID = this.selectedTabID;
			// console.log(this.selectedTabID)
			this.tabList.forEach(function(tab, index) {
				if (tab.id == selectedTabID) {
					// 如果有sub tab，也选中。如果没有匹配到，那就匹配第一个。通常会要求总有一个和父类相同
					tempIndex = index;
					if (tab.subList?.length > 0) {
						tab.subList.forEach(function(subtab, subIdx) {
							if (subtab.id == selectedTabID) {
								tempSubIndex = subIdx;
								//记录匹配的sub的一级目录值
								subParentIndex = index;
							}
						});
					}
				} else {
					if (tab.subList?.length > 0) {
						tab.subList.forEach(function(subtab, subIdx) {
							if (subtab.id == selectedTabID) {
								tempSubIndex = subIdx;
								//记录匹配的sub的一级目录值
								subParentIndex = index;
							}
						});
					}
				}
			});

			this.selectedSubTabIndex = tempSubIndex;

			/**
			 * 两种情况：
			 * 1. 前两个分支：selectedTabID有匹配到，则不用更改
			 * 2. reset分支：selectedTabID没有匹配到，走resetSelection，重新选择第0个一级tab，触发callback
			 */
			if (tempIndex >= 0) {
				// 匹配到一级tab
				this.selectedTabIndex = tempIndex;
			} else if (subParentIndex >= 0) {
				// 匹配到二级tab
				this.selectedTabIndex = subParentIndex;
			} else {
				// reset
				this.selectedSubTabIndex = 0;
				this.selectedTabIndex = 0;

				// 走到这里说明selectedTabID没有匹配到，触发reset
				this.resetSelection();
			}
		},
		// 手动触发一级tab的切换，如果存在二级栏目，则触发二级栏目切换。
		// 如果只有一级，则直接更改selectedTabID
		updateSelectedTabIndex: function(tabIndex) {
			// 使用index更新selectedTabID
			this.selectedTabIndex = tabIndex;

			// console.log("selectedTabIndex: " + this.selectedTabIndex);

			// todo: update tab id
			var subList = this.currentSubTabList;

			var tab = this.tabList[tabIndex];
			if (tab) {
				var currentTabID = tab.id;
				if (subList?.length > 0) {
					// 有sub tab
					// 找到id相同的subtab，找不到就用第一个。
					var subIndex = 0;
					subList.forEach(function(subtab, subIdx) {
						if (subtab.id == currentTabID) {
							subIndex = subIdx;
						}
					});
					// 用sub来触发
					this.updateSelectedSubTabIndex(subIndex);
				} else {
					// 清空
					this.selectedSubTabIndex = 0;
					this.selectedTabID = currentTabID;
				}
			} else {
				// reset
				this.resetSelection();
			}
		},
		// 被一级tab手动切换所触发、或者直接切换二级tab触发
		// 每次切换将触发selectedTabID切换
		updateSelectedSubTabIndex(subTabIndex) {
			// 使用index更新selectedTabId
			this.selectedSubTabIndex = subTabIndex;
			// console.log("selectedSubTabIndex: " + this.selectedSubTabIndex);

			var subList = this.currentSubTabList;
			var subtab = subList[subTabIndex];


			if (subtab) {
				// 合法值
				this.selectedTabID = subtab.id;
			} else {
				// 非法值, reset
				this.resetSelection();
			}
		},
		resetSelection() {
			if (this.tabList?.length > 0) {
				this.updateSelectedTabIndex(0);
			}
			else {
				// 不合法数据，清空
				this.selectedTabID = "";
			}
		},
	},
	name: "HeaderTab",
	components: {
		VueHorizontal,
	},
};
</script>
<style scoped>
.tab-container {
}

.tabs {
	border-bottom: 1px solid #e2e8f0;
}

.tab {
	height: 37px;
	margin: 0 6px;
	padding: 8px 12px 6px 12px;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
}

.tab.selected {
	border-bottom: 2px solid black;
}
</style>
